import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ExpenseFundApprovalsTable from './ExpenseFundApprovalsTable';

function ExpenseFundApprovals(props) {
    useEffect(() => {}, []);

    return (
        <div className="table__card">
            <ExpenseFundApprovalsTable
                fetchExpenseFundApprovalsUrl={fetchExpenseFundApprovalsUrl}
                fetchExpenseFundApprovalUrl={fetchExpenseFundApprovalUrl}
                updateExpenseFundApprovalUrl={updateExpenseFundApprovalUrl}
                displayApprovalStatuses={displayApprovalStatuses}
            />
        </div>
    );
}

export default ExpenseFundApprovals;
if (document.getElementById('ExpenseFundApprovals')) {
    var rootEl = document.getElementById('ExpenseFundApprovals');
    ReactDOM.render(
        <App>
            <ExpenseFundApprovals />
        </App>,
        rootEl,
    );
}
